import {
  Bell,
  Bot,
  BotMessageSquare,
  Brain,
  Heart,
  Headphones,
  MessageCircle,
  MessageCircleMore,
  MessageSquare,
  MessageSquareMore,
  MessageSquareText,
  MessagesSquare,
  Phone,
  Send,
  Sparkle,
  Sparkles,
  Star,
  User,
  WandSparkles,
  Zap,
} from 'lucide-react'

/** Canonical Lucide keys saved in AI Display config (kebab-case). */
export const LAUNCHER_BUTTON_ICON_OPTIONS = [
  { value: '', label: 'No Icon' },
  { value: 'sparkles', label: 'Sparkles' },
  { value: 'sparkle', label: 'Sparkle' },
  { value: 'wand-sparkles', label: 'Wand Sparkles' },
  { value: 'message-square-text', label: 'Message Square Text' },
  { value: 'message-square-more', label: 'Message Square More' },
  { value: 'messages-square', label: 'Messages Square' },
  { value: 'message-circle-more', label: 'Message Circle More' },
  { value: 'message-circle', label: 'Message Circle' },
  { value: 'message-square', label: 'Message Square' },
  { value: 'send', label: 'Send' },
  { value: 'brain', label: 'Brain' },
  { value: 'bot', label: 'Bot' },
  { value: 'bot-message-square', label: 'Bot Message Square' },
  { value: 'user', label: 'User' },
  { value: 'phone', label: 'Phone' },
  { value: 'bell', label: 'Bell' },
  { value: 'star', label: 'Star' },
  { value: 'heart', label: 'Heart' },
  { value: 'zap', label: 'Bolt' },
  { value: 'headphones', label: 'Support' },
]

const LAUNCHER_BUTTON_ICONS = {
  sparkles: Sparkles,
  sparkle: Sparkle,
  'wand-sparkles': WandSparkles,
  'message-square-text': MessageSquareText,
  'message-square-more': MessageSquareMore,
  'messages-square': MessagesSquare,
  'message-circle-more': MessageCircleMore,
  'message-circle': MessageCircle,
  'message-square': MessageSquare,
  send: Send,
  brain: Brain,
  bot: Bot,
  'bot-message-square': BotMessageSquare,
  user: User,
  phone: Phone,
  bell: Bell,
  star: Star,
  heart: Heart,
  zap: Zap,
  headphones: Headphones,
  // Legacy Material UI keys (existing saved configs).
  AssistantIcon: Bot,
  AutoAwesomeIcon: Sparkles,
  AutoFixHighIcon: WandSparkles,
  PsychologyIcon: Brain,
  ChatIcon: MessageCircle,
  MessageIcon: MessageSquare,
  QuestionAnswerIcon: MessagesSquare,
  SupportIcon: Headphones,
  SmartToyIcon: Bot,
  PersonIcon: User,
  PhoneIcon: Phone,
  NotificationsIcon: Bell,
  BoltIcon: Zap,
  StarIcon: Star,
  FavoriteIcon: Heart,
}

export function resolveLauncherButtonIcon(name) {
  const key = String(name || '').trim()
  if (!key) return null
  return LAUNCHER_BUTTON_ICONS[key] || null
}

export function launcherButtonAnimationClass(animation) {
  const a = String(animation || 'none').trim().toLowerCase()
  if (a === 'pulse') return 'ometrics-launcher-icon-pulse'
  if (a === 'spin') return 'ometrics-launcher-icon-spin'
  if (a === 'bounce') return 'ometrics-launcher-icon-bounce'
  return ''
}

/** Matches {@link ChatLauncher} / {@link InjectedLayout} border radius logic. */
export function resolveButtonBorderRadius(raw) {
  const s = String(raw ?? '').trim()
  if (!s) return '9999px'
  if (/^\d+$/.test(s)) return `${s}px`
  return s
}

/** Border-radius field in the builder (px stripped for number input). */
export function buttonBorderRadiusInputValue(raw) {
  const s = String(raw ?? '').trim()
  if (!s) return ''
  return s.replace(/px$/i, '')
}

export function LauncherButtonIconPreview({
  iconKey,
  animation = 'none',
  size = 16,
  className = '',
  color,
  strokeWidth = 2,
}) {
  const Icon = resolveLauncherButtonIcon(iconKey)
  if (!Icon) return null

  return (
    <span
      className={[launcherButtonAnimationClass(animation), className]
        .filter(Boolean)
        .join(' ')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color,
      }}
      aria-hidden
    >
      <Icon size={size} strokeWidth={strokeWidth} />
    </span>
  )
}
